import { takeLatest, put, cancel, select } from 'redux-saga/effects';

import { loggedUserIdSelector } from '../../context/selectors';
import * as success from '../../ui/success';
import * as error from '../../ui/error';
import * as uploadDocument from '../requests/upload-document-req';

function* handleUploadDocument({
  payload: { category, documents, subCategory, appointmentId },
}) {
  const userId = yield select(loggedUserIdSelector);

  const formData = new FormData();

  formData.append('document_category_id', category);
  formData.append('document_subcategory_id', subCategory);
  formData.append('appointmentId', appointmentId);
  formData.append('userId', userId);
  formData.append('file', documents);

  try {
    yield put(uploadDocument.actions.send(formData));
  } catch (e) {
    console.error('Error during upload visit documents', e);

    yield cancel();
  }
}

function* handleSuccessUpload() {
  yield put({
    type: success.consts.UPDATE,
    payload: { id: 'appointment.documents.successUpload' },
  });
}

function* handleErrorUpload() {
  yield put({
    type: error.consts.UPDATE,
    payload: { id: 'errors.common' },
  });
}

export default function* uploadDocumentSaga() {
  yield takeLatest(uploadDocument.actions.startUpload, handleUploadDocument);
  yield takeLatest(uploadDocument.actions.rejected, handleErrorUpload);
  yield takeLatest(uploadDocument.actions.succeed, handleSuccessUpload);
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/upload-document-saga.js